import { render, staticRenderFns } from "./allPosts.vue?vue&type=template&id=2f2ba205&scoped=true&"
import script from "./allPosts.vue?vue&type=script&lang=js&"
export * from "./allPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2ba205",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VAvatar,VBtn,VCard,VCardSubtitle,VCheckbox,VCol,VIcon,VImg,VSpeedDial})
